// src/utils/images.js
const isBrowser = typeof window !== "undefined";
const protocol  = isBrowser ? window.location.protocol : "http:";
const hostname  = isBrowser ? window.location.hostname : "localhost";
const port      = isBrowser ? window.location.port : "";

// פיתוח: פרונט על 3000, API/Uploads על 7010. פרודקשן: same-origin.
const isDev     = port === "3000" || hostname === "localhost";
const FRONT_BASE = isDev ? `${protocol}//${hostname}:3000` : `${protocol}//${hostname}`;
const API_BASE   = isDev ? `${protocol}//${hostname}:7010` : `${protocol}//${hostname}`;

export function normalizePath(p) {
  if (!p) return "";
  let s = String(p).trim()
    .replace(/\\/g, "/")        // backslashes -> /
    .replace(/^\.\//, "")       // מסיר "./" בתחילת הנתיב
    .replace(/\/{2,}/g, "/");   // מאחד // כפולים
  if (!s.startsWith("/")) s = "/" + s; // מבטיח סלאש מוביל
  return s;
}

// מרכיב URL מלא לכל תמונה מה-DB
export function resolveImage(src) {
  if (!src) return `${FRONT_BASE}/img/placeholder.png`;

  // URL מלא? נחזיר כמו שהוא
  if (/^https?:\/\//i.test(src)) return src;

  const norm = normalizePath(src);
  const lower = norm.toLowerCase();

  // public/img בלקוח → על 3000 בפיתוח
  if (lower.startsWith("/img/")) {
    // מקודדים רק את שם הקובץ/תיקיות, לא את כל ה-URL
    return FRONT_BASE + encodeURI(norm);
  }

  // wwwroot/uploads בשרת → על 7010 בפיתוח
  if (lower.startsWith("/uploads/")) {
    return API_BASE + encodeURI(norm);
  }

  // אם בטעות נשמר בלי הסלאש או עם שם תיקייה אחר - ננסה לנחש:
  if (lower.startsWith("img/"))     return FRONT_BASE + encodeURI("/" + norm);
  if (lower.startsWith("uploads/")) return API_BASE   + encodeURI("/" + norm);

  // ברירת מחדל: נניח שזה תוכן מהשרת
  return API_BASE + encodeURI(norm);
}
